import { Employee } from "@/features/modules/employee/objects/Employee";
import { Examination } from "@/features/modules/examination/objects/Examination";

export class EmployeeLastExamination {
  public employee: Employee | undefined = undefined;
  public lastExamination: Examination | undefined = undefined;
}
